export default __webpack_public_path__ + "static/media/graphic-5.2a7650dd.png";